import { forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const ICON_COLLEGE_PLACEHOLDER_TEST_ID = "icon-college-placeholder";

const iconVariants = cva("inline-block", {
    variants: {
        color: {
            blue: "fill-blue-80 stroke-blue-80",
            gray: "fill-gray-50 stroke-gray-50",
            white: "fill-white stroke-white",
            "blue-outline": "fill-white stroke-blue-80",
        },
    },
    defaultVariants: {
        color: "blue",
    },
});

interface IconProps extends VariantProps<typeof iconVariants> {
    title?: string;
    className?: string;
}

const IconCollegePlaceholder = forwardRef<SVGSVGElement, IconProps>(
    ({ color, title, className }, ref) => (
        <svg
            ref={ref}
            viewBox="0 0 27 24"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            className={cn(iconVariants({ color }), className)}
            data-testid={ICON_COLLEGE_PLACEHOLDER_TEST_ID}
        >
            <title className="sr-only">{title || "College Logo Placeholder"}</title>
            <path
                d="M8.25 5.5C8.25 5.10655 8.43524 4.73607 8.75 4.5L12.75 1.5C13.1944 1.16667 13.8056 1.16667 14.25 1.5L18.25 4.5C18.5648 4.73607 18.75 5.10655 18.75 5.5V23.25H16.25V22C16.25 20.4812 15.0188 19.25 13.5 19.25C11.9812 19.25 10.75 20.4812 10.75 22V23.25H8.25V5.5Z"
                strokeWidth="1.5"
            />
            <path
                d="M21.75 9.75H25C25.6904 9.75 26.25 10.3096 26.25 11V23.25H21.75V9.75Z"
                strokeWidth="1.5"
            />
            <path
                d="M0.75 11C0.75 10.3096 1.30964 9.75 2 9.75H5.25V23.25H0.75V11Z"
                strokeWidth="1.5"
            />
        </svg>
    ),
);

IconCollegePlaceholder.displayName = "IconCollegePlaceholder";
export default IconCollegePlaceholder;
